import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';

import { CookieService } from 'ngx-cookie-service';

import { environment } from '@environments/environment';

import { retryWithDelay } from '@core/operators/retry-delay';

import { AllianceDetailService } from '@account/services/alliance-detail.service';
import { AuthService } from '@auth/auth.service';

import { DetailInfoRequest } from '@core/model/detail-info-request';
import { SimulatorPropertiesType } from '@credit/simulator/models';

import { ALLIANCE_TYPE_ENUMERATION, SIMULATION_PROPERTIES_ENUMERATION } from '@credit/simulator/config';

@Component({
  selector: 'app-alliance-start',
  templateUrl: './alliance-start.component.html',
  styleUrls: ['./alliance-start.component.css'],
})
export class AllianceStartComponent implements OnInit, OnDestroy {
  public simulatorProperties: SimulatorPropertiesType;
  public allianceName: string;
  public isWallet: boolean;
  public isAuthenticated: boolean;
  public showSimulator: boolean;
  public domain: string;
  public showRequestAmount: boolean;

  private readonly unSubscribe$: Subject<void>;

  constructor(
    private authService: AuthService,
    private allianceDetailService: AllianceDetailService,
    private activatedRoute: ActivatedRoute,
    private cookieService: CookieService
  ) {
    this.simulatorProperties = {} as SimulatorPropertiesType;
    this.showSimulator = false;
    this.domain = environment.domain;
    this.showRequestAmount = false;
    this.unSubscribe$ = new Subject();
  }

  public ngOnInit(): void {
    this.getUriParams();
    this.validateEnableAmountSlider();
    this.isAuthenticated = this.authService.isAuthenticated();
    this.cookieService.set('isNewLoan', JSON.stringify(true), 1, '/', this.domain);
  }

  public ngOnDestroy(): void {
    this.unSubscribe$.next();
    this.unSubscribe$.complete();
  }

  private setSimulator(): void {
    this.simulatorProperties.buttonLabel = 'PIDE TU RAPIPLAZO YA';
    this.simulatorProperties.type = ALLIANCE_TYPE_ENUMERATION.ALLIANCE;
  }

  private validateEnableAmountSlider(): void {
    const ac = sessionStorage.getItem('ac') || '';
    this.allianceDetailService
      .canChangeFrontAlliance(ac)
      .pipe(retryWithDelay(1000, 3), takeUntil(this.unSubscribe$))
      .subscribe((response) => {
        this.isWallet = response;
        this.setSimulator();
      });
  }

  private getUriParams(): void {
    this.activatedRoute.queryParams.pipe(takeUntil(this.unSubscribe$)).subscribe((params) => {
      const ac = params['ac'] || null;
      const id = params['id'] || null;
      if (id != null && ac != null) {
        sessionStorage.setItem('cai', id);
        sessionStorage.setItem('ac', ac);
        this.getValuesCustomerAlliance(id);
      }
    });
  }

  private _buildRequestAllianceDetail(idInfoAlliance: string): DetailInfoRequest {
    let keys: string[] = ['amount', 'term', 'nameAlliance'];
    return {
      idInfoAlliance: idInfoAlliance,
      keyList: keys,
    };
  }

  private getValuesCustomerAlliance(idInfoAlliance: string): void {
    this.allianceDetailService
      .getInfoDetail(this._buildRequestAllianceDetail(idInfoAlliance))
      .pipe(retryWithDelay(1000, 3), takeUntil(this.unSubscribe$))
      .subscribe((data: unknown) => {
        const response = data as { amount: string; term: string; nameAlliance: string };
        this.allianceName = response.nameAlliance;
        if (response.amount !== undefined) {
          this.cookieService.set(SIMULATION_PROPERTIES_ENUMERATION.AMOUNT, response.amount, 1, '/', this.domain);
          sessionStorage.setItem(SIMULATION_PROPERTIES_ENUMERATION.AMOUNT, response.amount);
        }
        if (response.term != undefined) {
          this.cookieService.set(SIMULATION_PROPERTIES_ENUMERATION.TERM, response.term, 1, '/', this.domain);
          sessionStorage.setItem(SIMULATION_PROPERTIES_ENUMERATION.TERM, response.term);
        }
        this.showSimulator = true;
      });
  }
}
